module.exports = __webpack_public_path__ + "img/banner_text.0900301c.png";